import './application.css'
import { createInertiaApp } from '@inertiajs/react'
import { createRoot } from 'react-dom/client'
import { Toaster } from '@/components/ui/sonner'

createInertiaApp({
  resolve: (name) => {
    const pages = import.meta.glob(['../pages/**/*.tsx', '!**/*.test.tsx'], { eager: true })
    const page = pages[`../pages/${name}.tsx`]
    if (!page) {
      throw new Error(`Page not found: ${name}`)
    }
    return page
  },
  setup({ el, App, props }) {
    createRoot(el).render(
      <>
        <App {...props} />
        <Toaster position="bottom-right" richColors />
      </>
    )
  },
})
